(function(){
  'use strict';

  function formatMoney(cents){
    var value=Number(cents);
    if(!Number.isFinite(value)) return '';
    return new Intl.NumberFormat('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}).format(value/100)+' €';
  }

  function normalizeStaticPrices(){
    document.querySelectorAll('[data-wc-price-cents]').forEach(function(node){
      var formatted=formatMoney(node.getAttribute('data-wc-price-cents'));
      if(!formatted) return;
      var prefix=node.getAttribute('data-wc-price-prefix')||'';
      var wanted=prefix+formatted;
      if(node.textContent.trim()!==wanted) node.textContent=wanted;
    });
  }

  function normalizeProductPrice(root){
    if(!root || root.dataset.wcPriceReady==='true') return;
    root.dataset.wcPriceReady='true';
    var priceNode=root.querySelector('[data-product-price]');
    var variantNode=root.querySelector('[data-product-variants]');
    var idNode=root.querySelector('[data-variant-id]');
    if(!priceNode||!variantNode||!idNode) return;
    var variants=[];
    try{variants=JSON.parse(variantNode.textContent||'[]')}catch(error){return}

    function sync(){
      var id=String(idNode.value||'');
      var variant=variants.find(function(item){return String(item.id)===id});
      if(!variant) return;
      var wanted=formatMoney(variant.price);
      if(wanted&&priceNode.textContent.trim()!==wanted) priceNode.textContent=wanted;
    }

    sync();
    root.addEventListener('click',function(event){
      if(event.target.closest('.wc-option-button')) window.setTimeout(sync,20);
    });
    var observer=new MutationObserver(function(){window.requestAnimationFrame(sync)});
    observer.observe(priceNode,{childList:true,characterData:true,subtree:true});
  }

  function init(){
    normalizeStaticPrices();
    document.querySelectorAll('[data-wc-product]').forEach(normalizeProductPrice);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
